module.exports = __webpack_public_path__ + "img/collection-diamondJewelryEarrings@2x.0412fab.jpg";